import { DIMENSIONS_NEAR_DOWNLOAD, DIMENSIONS_NEAR_SLIDER } from "./constants";
import { snapAndFormatDimensions } from "./formatting";
import { measureLabelPreview } from "./measurements";
import { debugLog, getElement, getElements, pxToInches } from "./utils";

const __DEBUG = false;

const getDisplayElements = () =>
  Array.from(getElements(DIMENSIONS_NEAR_DOWNLOAD)).concat([getElement(DIMENSIONS_NEAR_SLIDER)]);

let lastDisplayText = "";

/* Updates the label dimensions (aspect ratio) text beneath the slider and near the download button. */
export const updateDisplayedDimensions = () => {
  if (__DEBUG) debugLog("[updateDisplayedDimensions] Start...");

  const displayElements = getDisplayElements();
  if (!displayElements) {
    console.error("[updateDisplayedDimensions] #sidebar-preview-dimensions not found. Aborting.");
    return;
  }

  let widthPx = 0;
  let heightPx = 0;
  try {
    const measured = measureLabelPreview();
    widthPx = measured.widthPx;
    heightPx = measured.heightPx;
  } catch (err) {
    console.error("[updateDisplayedDimensions] Error measuring label:", err);
    setInnerHtml(displayElements, "");
    return;
  }

  if (widthPx <= 0 || heightPx <= 0) {
    console.warn(`[updatePreviewDimensions] Zero height or width?`, { widthPx, heightPx });
    setInnerHtml(displayElements, "");
    return;
  }

  const rawWidth = pxToInches(widthPx);
  const rawHeight = pxToInches(heightPx);
  if (__DEBUG) debugLog(`[updatePreviewDimensions] Raw inches:`, { rawWidth, rawHeight });

  const displayText = snapAndFormatDimensions(rawWidth, rawHeight);
  if (displayText === lastDisplayText) {
    debugLog(`[updatePreviewDimensions] Unchanged.`);
    return;
  } else {
    lastDisplayText = displayText;
  }

  debugLog(`[updatePreviewDimensions] => ${displayText}`);
  setInnerHtml(
    displayElements,
    `<div>Label dimensions:</div><div class="no-wrap">${displayText}</div>`
  );
};

const setInnerHtml = (elements, content) => {
  for (const element of elements) {
    element.innerHTML = content;
  }
};
